// extracted by mini-css-extract-plugin
module.exports = {"wyki552":"wyki552","cda6ynm":"cda6ynm"};